import queryString from 'query-string';
import typeCheck from 'common/util/typeCheck';

export const RENTAL_APPLICATION_STEP_IN_PERSON_TOUR = 'inPersonTour';
export const RENTAL_APPLICATION_STEP_REQUIREMENTS = 'agree';
export const RENTAL_APPLICATION_STEP_PERSONAL_INFO = 'credit';
export const RENTAL_APPLICATION_STEP_PAY = 'pay';
export const RENTAL_APPLICATION_STEP_VERIFICATION = 'verification';
export const RENTAL_APPLICATION_STEP_FORM = 'form';

export const getRentalApplicationUrl = ({ userId, listingId, rentalApplicationStepId, queryObject = {} }) => {
  typeCheck('userId::PositiveNumber', userId);
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('rentalApplicationStepId::Maybe String', rentalApplicationStepId);

  return `/rental-application/${userId}/${listingId}/${
    rentalApplicationStepId || RENTAL_APPLICATION_STEP_REQUIREMENTS
  }?${queryString.stringify(queryObject)}`;
};

export const getRedirectRentalApplicationUrl = () => {
  return '/profile';
};
